/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ExpiryStatus, ScreenType, VideoResolution, VodItemType } from 'client-code/vod-browse';

import { ImageType } from '../../../../core/utils/ImageUrlGenerator';

export const ContentTileType = {
    [VodItemType.EpisodeVodItem.toLowerCase()]: 'episode',
    [VodItemType.FolderVodItem.toLowerCase()]: 'folder',
    [VodItemType.MovieVodItem.toLowerCase()]: 'movie',
    [VodItemType.SpecialVodItem.toLowerCase()]: 'special',
    [VodItemType.UnifiedCollectionVodItem.toLowerCase()]: 'collection',
    [ScreenType.PosterBrowseMixed.toLowerCase()]: 'posterbrowsemixed',
    [ScreenType.PosterBrowseMovie.toLowerCase()]: 'posterbrowsemovie',
    [ScreenType.TextCurrentRentals.toLowerCase()]: 'textcurrentrentals',
}; // more types can be added here if needed

type TContentTileType = (typeof ContentTileType)[keyof typeof ContentTileType];
export interface IContentTileProps {
    type: TContentTileType;
    title?: string;
    digObjectId?: string; // represents image object id for dig server
    isAdult?: boolean;
    percentWatched?: number;
    videoResolution?: VideoResolution;
    expiryStatus?: ExpiryStatus;
}

export interface IViewAllTileProps {
    screenType?: string;
    isSelected?: boolean;
}

export interface IEmptyTileProps {
    isEmpty: boolean;
}

export const ContentTileImageType = {
    MOVIE: 'MOVIE' as ImageType,
    EPISODE: 'EPISODE' as ImageType,
    SPORTS: 'SPORTS' as ImageType,
    TEAM: 'TEAM' as ImageType,
    COLLECTION: 'COLLECTION' as ImageType,
};
